/**
 * @prettier
 */

import React from 'react';
import CardCorrectionReview from '../../CardCorrectionReview/CardCorrectionReview';

const OtherThingsToReview = () => (
  <CardCorrectionReview.Box>
    <CardCorrectionReview.Title>Other Things To Review</CardCorrectionReview.Title>
    <CardCorrectionReview.Tips />
  </CardCorrectionReview.Box>
);

export default OtherThingsToReview;
